<template>
    <v-window-item value="transfers">
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center mb-4">
                        <h2 class="text-h6">Asset Transfers</h2>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="pa-1">
                    <v-data-table
                        :headers="transferHeaders"
                        :items="transfersData"
                        :loading="loading"
                        :hover="true"
                        density="compact"
                        elevation="0"
                        class="border-sm rounded-md"
                    >
                    
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-window-item>
</template>

<script>

export default {
    props: {
        transfersData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
        }
    },
    components: {},
    data: () => ({
        dialog: false,
        loading: false,
        transferHeaders: [
            { title: "Code", key: "asset_transfer.code", align: "center", sortable: false },
            { title: "Transfer Date", key: "asset_transfer.transfer_date", align: "center", sortable: false },
            { title: "Transfer From", key: "asset_transfer.from_asset_location.name", align: "center", sortable: false },
            { title: "Transfer To", key: "asset_transfer.to_asset_location.name", align: "center", sortable: false },
        ],
    }),
    computed: {},
    watch: {
        transfersData: {
            handler(newVal, oldVal) {
                console.log('New transfersData:', newVal)
                console.log('Old transfersData:', oldVal)
            },
            deep: true, // optional if array objects may change internally
            immediate: true // optional if you want it to run right away on mount
        }
    },
    created() {
    },
    methods: {},
    setup(props, {emit}){},
    mounted() {
        
    },
}
</script>